import { Button } from '@material-ui/core';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledPrivacyPolicy = styled.div`
  h2 {
    padding-top: 30px;
  }

  h2:first-child {
    padding-top: 0px;
  }

  h3 {
    font-weight: bold;
    font-size: 1.2rem;
    padding: 30px 0px 10px;
    color: #231815;
  }

  h4 {
    font-weight: bold;
    padding: 20px 0px 10px;
  }

  p {
    line-height: 1.5rem;
  }

  ol li {
    line-height: 1.2rem;
    margin-left: 1rem;
    margin-bottom: 10px;
    list-style: decimal;
  }

  ul li {
    margin-top: 1rem;
    margin-left: 3rem;
  }

  @media screen and (max-width: 751px) {
    #Wrap #privacy ul li {
      margin-left: 1.5rem;
    }
  }

  .linkIndex {
    text-align: center;
    margin: 20px auto 0px auto;
  }
`;

/**
 * 個人情報保護に関するページ
 */
const PrivacyPolicy: FC = () => {
  return (
    <StyledPrivacyPolicy>
      <h2>プライバシーポリシー</h2>
      <p className="right">2020年12月1日制定</p>
      <br />
      <dl>
        <dt>
          コロナに負けるな！買って応援
          北海道（以下、当サイトと称す）は、一般社団法人北海道国際流通機構の運営のもと、北海道テレビ放送株式会社（以下、ＨＴＢと称す）が委託を受け個人情報の取得・管理を行っており、ＨＴＢの
          <Link to="/PrivacyPolicyHTB">「個人情報保護方針」</Link>および
          <Link to="/PrivacyPolicyHTB">「個人情報取り扱い」</Link>
          に基づき適正に取り扱いいたします。
        </dt>
        <br />
        <h4>アクセス解析ツールについて</h4>
        当ブログでは、Googleによるアクセス解析ツール「Googleアナリティクス」を利用しています。このGoogleアナリティクスはトラフィックデータの収集のためにクッキー（Cookie）を使用しております。トラフィックデータは匿名で収集されており、個人を特定するものではありません。
        <br />
        <br />
        <h4>個人情報の扱いについて</h4>
        取得した個人情報は、商品の決済および、発送、お客様応対を目的として、カード決済会社、ヤマト運輸株式会社、ヤマトシステム開発株式会社、一般社団法人北海道国際流通機構等と共同利用させていただきます。
        <br />
        <dt>
          個人情報の取り扱いに関するお問い合せ、ご意見、苦情は、下記へご連絡ください。
        </dt>
        <br />
        <h4>一般社団法人 北海道国際流通機構</h4>
        <li>住所： 〒060–0052 札幌市中央区南２条東1丁目1-12 フラーテ札幌4F</li>
        <li>メールアドレス： souseimarche@hi-do.or.jp</li>
        <br />
        <br />
        <dd>
          直接来社されてのお申出はお受けいたしかねますので、その旨ご了承ください。
        </dd>
      </dl>
      <div className="linkIndex">
        <Button variant="contained" color="primary" component={Link} to="/">
          前のページへ戻る
        </Button>
      </div>
    </StyledPrivacyPolicy>
  );
};

export default PrivacyPolicy;
